"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Menu_1 = tslib_1.__importDefault(require("@mui/icons-material/Menu"));
const RailIconButton_1 = tslib_1.__importDefault(require("./RailIconButton"));
/**
 *
 * This component is only intended to be used internally in @mnemonic/mui5
 *
 * @internal
 */
const RailMenuButton = (props) => (react_1.default.createElement(RailIconButton_1.default, { ...props, "aria-label": "Menu", isSelected: false, children: react_1.default.createElement(Menu_1.default, null), sx: { mb: 3 } }));
exports.default = RailMenuButton;
